import { ComponentToPrint } from './ComponentToPrintDefault';
import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import { uAPIlocal } from '../../lib/config';
import _print from "../../../assets/font-awesome/black/png/128/print.png";

function Preview({ item }) {
  const [dataLoaded, setDataLoaded] = useState(false);
  const onBeforeGetContentResolve = useRef();
  const componentRef = useRef();
  const [show, setShow] = React.useState(false);

  const handleOnBeforeGetContent = () => {
    return new Promise((resolve) => { // `react-to-print` will wait for this Promise to resolve before continuing
      // Load data
      onBeforeGetContentResolve.current = resolve;
      setDataLoaded(true); // When data is done loading

      setTimeout(() => {
        setDataLoaded(false);
      }, 2000);

    });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: handleOnBeforeGetContent,
  });

  useEffect(() => {

    console.log("INI PROPS B", item)

    if (item.ID_PEMBAYARAN) {
      setShow(true)
    } else { setShow(false) }


    if (dataLoaded) {

      if (item.ID_PEMBAYARAN) {
        setShow(true)
      } else { setShow(false) }

      // Resolves the Promise, telling `react-to-print` it is time to gather the content of the page for printing
      onBeforeGetContentResolve.current();
    }
  }, [dataLoaded, onBeforeGetContentResolve]);

  useEffect(() => {

    if (item.ID_PEMBAYARAN) {
      setShow(true)
    } else { setShow(false) }

  }, []);

  return (
    <div className="bg-gray-200 p-6">
      <button
        className={show ? "btn btn-info btn-sm rounded-0" : "btn btn-light btn-sm rounded-0"}
        // className={"btn btn-info btn-sm rounded-0"}
        type="button"
        data-toggle="tooltip"
        data-placement="top"
        title="Print Rincian Biaya"
        onClick={handlePrint}
        disabled={show ? false : true}
        style={{
          backgroundImage: "url(" + _print + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px",
        }}>
        {/* <i className="fa fa-print" /> */}
      </button>
      {/* <ComponentToPrint item={detail ? detail : item} ref={componentRef} /> */}
      <ComponentToPrint item={item} ref={componentRef} />
    </div>
  );
}

export default Preview;



